import { createAction, props } from '@ngrx/store';
import { ISite, ISiteResponse } from '@shared/site.interface';

export const searchSitesSuccess = createAction(
  '[Sites] Search Sites Success',
  props<{ sites: ISiteResponse }>(),
);

export const loadingSites = createAction('[Sites] Loading Sites');

export const searchSitesFailure = createAction(
  '[Sites] Search Sites Failure',
  props<{ error: string }>(),
);

export const loadingSiteDetails = createAction(
  '[Sites] Loading Site Details',
  props<{ siteId: string }>(),
);

export const getSiteDetailsSuccess = createAction(
  '[Sites] Get Site Details Success',
  props<{ site: ISite }>(),
);

export const getSiteDetailsFailure = createAction(
  '[Sites] Get Site Details Failure',
  props<{ siteId: string; error: string }>(),
);
